module.exports = __webpack_public_path__ + "static/karriere1-cb7854cb2d92e8ce593baa0d721ed7ad.jpg";